import React from 'react';
import { useState, useEffect, useContext } from "react";
import { MyContext } from "../../context";

function TicketRightBar(props){

  const {RightLinkSelection, updateRightLinkSelection } = useContext(MyContext);
  const active = "BIcon active";
  const notActive = "BIcon";
  

    return (
       
        <>
        
      
<div className="card" style={{width: "18rem;", marginBottom: "30px"}}>


<div className="card-body">
  <div style={{display: "flex"}}>
    
  <p className="card-title"><strong>{props.name}</strong></p>

{/* 
  <span className='info leftAling'>
  <div class="dropdown">
                <span className="info" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" style={{marginBottom:"20px"}}>
                  <span class="material-symbols-rounded">more_horiz</span>
                </span>
                <div class="dropdown-menu" aria-labelledby="" style={{marginTop:"5px", marginLeft:"20px"}}>
                <a class="dropdown-item" href="#">Last 24 Hours</a>
    <a class="dropdown-item" href="#">Last Week</a>
    <a class="dropdown-item" href="#">Last 30 Days</a>
  </div></div>

</span>
*/}

  </div>

  <div className='smallInfo' style={{display: "flex", flexDirection: "column"}}>
    <div style={{marginBottom:"15px"}}>
    <span class="material-symbols-rounded writing">location_on</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>{props.location}</span>
    </div>
    <div>
  <span class="material-symbols-rounded writing" >calendar_month</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Ticket Logged: </strong>{props.date}</span>
    </div>

  </div>
  <hr />

  <p><strong>Description </strong></p>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">description</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>{props.description}</span>
  
  </div>
  <hr />
 
   <p><strong>Inverter & Battery</strong></p>
   <div className='smallInfo' style={{display: "flex", flexDirection: "column"}}>
    
    <div style={{marginBottom:"15px"}}>
    <span class="material-symbols-rounded writing">charger</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Inverter: </strong>{props.inverter}</span>
    </div>

    <div>
    <span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}><strong>Battery: </strong>{props.type}</span>
    </div>
  </div>
  <hr />

  

  <p><strong>Faults: </strong></p>
   <div className='smallInfo' style={{display: "flex"}}><span class="material-symbols-rounded writing">battery_5_bar</span> <span style={{marginTop: "-3px", paddingLeft:"5px"}}>{props.fault}</span>
  
  </div>


  {/*
  <hr />

<div  style={{display: "flex"}}>


  <span className={RightLinkSelection === "Pack" ? active : notActive} onClick={() => updateRightLinkSelection("Pack")}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >dns</span> <span style={{paddingTop:"2px", paddingLeft:"5px"}}>Packs</span></span>


  <span className={RightLinkSelection === "Battery" ? active : notActive} onClick={() => updateRightLinkSelection("Battery")}><span class="material-symbols-rounded size"  style={{paddingTop:"0px"}} >bolt</span> <span  style={{paddingTop:"2px", paddingLeft:"5px"}}>Battery</span></span>
  <span className={RightLinkSelection === "Cell" ? active : notActive} onClick={() => updateRightLinkSelection("Cell")}><span class="material-symbols-rounded size" style={{paddingTop:"0px"}}>battery_6_bar</span> <span  style={{paddingTop:"2px", paddingLeft:"5px"}}>Cells </span></span>
</div>


             

              {RightLinkSelection === "Bank" ? "":  <div>
                <span className='BIcon2' onClick={() => updateRightLinkSelection("Bank")}><span class="material-symbols-rounded size" style={{paddingTop:"4px", marginRight:"5px"}}>monitoring</span> <span style={{paddingTop:"5px"}}> Bank Graph</span></span>
              </div>}
*/}


</div>




</div>

             

        </>
    )
}

export default TicketRightBar;